<style lang="scss">
.border-top {
    border-top: 1px dashed #8cb9e8;
}
.height-32 {
    height: 32px;
}
// customerupload
</style>

<template>
    <div class="salesafter">
        <div class="clearfix margin-top-20" v-if="type == 'add'">
            <vForm :label-width="120">
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('erp.b2c.search_channelorder', {
                                defaultValue: '渠道订单号',
                            })
                        "
                    >
                        <div v-if="type == 'query'">{{ formData.orderNo }}</div>
                        <!-- {{formData.orderServiceNo}} -->
                        <vInput
                            v-else
                            readonly
                            v-model="inputOrderNo"
                            style="width: 80%; float: left"
                            :disabled="!showSource"
                        >
                            <vIcon
                                v-show="showSource"
                                type="search"
                                center
                                slot="suffix"
                                style="padding: 6px; pointer-events: initial"
                                size="18"
                                @click.native="handleOrderList"
                            />
                        </vInput>
                        <vCheckbox
                            v-if="addunsourcedInfo"
                            class="margin-right-20"
                            :trueValue="1"
                            v-model="noOrderSource"
                            :disabled="type != 'add'"
                            @on-change="changeOrderSpource(noOrderSource)"
                            >{{
                                $t("erp.aftersales.noorder", {
                                    defaultValue: "无订单",
                                })
                            }}</vCheckbox
                        >
                    </vFormItem>
                </vCol>
                <vCol span="12" v-if="dataorders.length > 0">
                    <Table
                        style="margin-left: 120px; margin-bottom: 20px"
                        :columns="columnsorder"
                        :data="dataorders"
                        size="small"
                        ref="table"
                        border
                    >
                    </Table>
                </vCol>
            </vForm>
        </div>
        <div class="margin-bottom-10" v-if="type != 'add'">
            {{
                $t("erp.aftersales.orderServiceNo", { defaultValue: "售后单" })
            }}：{{ formData.orderServiceNo }}
            <div class="margin-left-10 b2cspan-primary span-padding">
                {{ filterStatus(formData.orderStatus) }}
            </div>
        </div>
        <compWrapper
            :title="
                $t('erp.aftersales.ordernews', { defaultValue: '订单信息' })
            "
            theme="primary"
            v-if="showSource"
        >
            <compFormQuery
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="130"
            ></compFormQuery>
            <!-- <compFormEdit v-else class="margin-top-15 margin-right-15" ref="editform" :formdata="getBase" v-model="formData" :labelWidth="120"/> -->
        </compWrapper>
        <compWrapper
            :title="
                $t('erp.b2c.product_information', { defaultValue: '产品信息' })
            "
            theme="info"
            v-if="showSource"
        >
            <vTable
                class="margin-20"
                :columns="columns"
                :data="datalist"
                size="small"
                ref="table"
                border
            >
            </vTable>
        </compWrapper>
        <!-- 展示三个框 退款 退货 补发 -->
        <compWrapper
            :title="
                $t('erp.aftersales.writenews', { defaultValue: '填写信息' })
            "
            theme="warning"
        >
            <div class="margin-20 text-left">
                <vIcon
                    v-if="type != 'query'"
                    type="ios-medical"
                    style="color: #ed3f14"
                ></vIcon
                ><span class="margin-right-20">{{
                    $t("erp.aftersales.aftertypes", {
                        defaultValue: "售后单类型",
                    })
                }}</span>

                <!-- <vCheckbox v-show="SYSID == '1000147'" class="margin-right-20" v-for="(json,index) in checklist1" :key="index" :trueValue="json.value" v-model="checkoutList1" :disabled="oldcheckoutList.indexOf(json.value)>-1 || type=='query'">{{json.label}}</vCheckbox> -->

                <vCheckbox
                    class="margin-right-20"
                    v-for="(json, index) in checklist"
                    :key="index"
                    :trueValue="json.value"
                    v-model="checkoutList"
                    :disabled="
                        oldcheckoutList.indexOf(json.value) > -1 ||
                        type == 'query'
                    "
                    >{{ json.label }}</vCheckbox
                >
            </div>

            <compRefund
                v-if="checkoutList.indexOf('refund') > -1"
                class="border-top"
                :orderServiceRefund="orderServiceRefund"
                :accountFlag="formData.sourceChannel"
                :tabledata="refundtable"
                ref="refRefund"
                :querytype="querytype"
                :indexid="activeids"
            ></compRefund>
            <compGoods
                v-if="checkoutList.indexOf('goods') > -1"
                class="border-top"
                :orderServiceBaseInfo="orderServiceBaseInfo"
                :orderServiceReturn="orderServiceReturn"
                :accountFlag="formData.sourceChannel"
                :tabledata="returntable"
                ref="refGoods"
                :querytype="querytype"
                :indexid="activeids"
                @on-update="getDetail"
            ></compGoods>
            <compReplace
                v-if="checkoutList.indexOf('replace') > -1"
                class="border-top"
                :orderServiceReplacement="orderServiceReplacement"
                :accountFlag="formData.sourceChannel"
                :tabledata="placementtable"
                ref="refReplace"
                :querytype="querytype"
                :indexid="activeids"
            ></compReplace>

            <div v-show="type != 'query'" class="text-right margin-right-20">
                <vButton
                    theme="primary"
                    class="margin-right-10"
                    @click="submit"
                    >{{
                        $t("global.common.save", { defaultValue: "保存" })
                    }}</vButton
                >
                <vButton @click="cancel()">{{
                    $t("global.common.operation_cancel", {
                        defaultValue: "取消",
                    })
                }}</vButton>
            </div>
        </compWrapper>
        <!-- stockOpLogList -->
        <compWrapper
            :title="$t('global.log.name', { defaultValue: '操作历史' })"
            theme="gray"
            v-if="type == 'query'"
        >
            <compLog :data="stockOpLogList" :columns="logcolumns"></compLog>
        </compWrapper>
        <!-- 全局弹框 -->
        <Modal
            class="hidefooter comcusmodal"
            v-model="handle.show"
            :mask-closable="false"
            v-bind="handle"
        >
            <component
                ref="cusref"
                :is="handle.component"
                @on-close="handle = {}"
                v-bind="handle"
                @on-update="getBtnId"
                @on-closeCus="closeCusfun"
            ></component>
            <footer slot="footer" v-show="handle.footer"></footer>
        </Modal>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import {
    HttpGetOneafSalesByManagement,
    HttpGetOrderNo,
    HttpsaveOneafSales,
} from "@/service/aftersales/aftersales";
import { mapState, mapGetters } from "vuex";
import compRefund from "./refundorder";
import compGoods from "./goodsorder";
import compReplace from "./replacementorder";
import orderTablelist from "@/views/aftersales/saleorders/orderTablelist";
import comCusUpdate from "@/views/aftersales/saleorders/updatesaleorders";
import tipText from "@/views/aftersales/saleorders/tipText";

import comUpdate from "@/views/aftersales/saleorders/queryupdate";
export default {
    props: ["activeids", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compRefund,
        compGoods,
        compReplace,
        orderTablelist,
        compLog: () => import("@components/templates/log"),
        comCusUpdate,
        comUpdate,
        tipText,
    },
    data() {
        return {
            loading: false,
            datalist: [],
            SYSID: global.SYSID,
            type: this.$route.params.type,
            formData: {
                orderServiceNo: "",
            },
            checkoutList: ["refund", "goods", "replace"],
            checkoutList1: ["refund", "goods"],
            oldcheckoutList: [],
            dataorders: [],
            checklist: [
                {
                    value: "refund",
                    label: this.$t("erp.aftersales.refund", {
                        defaultValue: "退款",
                    }),
                },
                {
                    value: "goods",
                    label: this.$t("erp.aftersales.goods", {
                        defaultValue: "退货",
                    }),
                },
                {
                    value: "replace",
                    label: this.$t("erp.aftersales.replace", {
                        defaultValue: "补发",
                    }),
                },
            ],
            checklist1: [
                {
                    value: "refund",
                    label: this.$t("erp.aftersales.refund", {
                        defaultValue: "退款",
                    }),
                },
                {
                    value: "goods",
                    label: this.$t("erp.aftersales.goods", {
                        defaultValue: "退货",
                    }),
                },
            ],
            // refund:true,
            // goods:true,
            // replace:true,
            id: this.$route.query.id,
            orderServiceBaseInfo: {},
            orderServiceRefund: {},
            orderServiceReturn: {},
            orderServiceReplacement: {},

            refundtable: [],
            returntable: [],
            placementtable: [],
            stockOpLogList: [],
            handle: {
                show: false,
                title: "",
                component: null,
            },
            btnindexid: "",
            inputOrderNo: "",
            hasTip: false,
            noOrderSource: 0,
            showSource: true,
        };
    },
    created() {
        this.addunsourcedInfo = this.handleAuth(
            "erp.orderService.addunsourced"
        );
        if (this.type != "add") {
            this.getDetail();
        }
    },
    computed: {
        ...mapState("boss", ["warehouseList"]),
        ...mapGetters("diction", ["getNewProductList"]),
        getBase() {
            const { orderType, orderState } = this.formData;
            let showquery = true;
            return [
                {
                    label: this.$t("erp.b2c.search_ordernumber", {
                        defaultValue: "订单号",
                    }),
                    key: "orderNo",
                    query: showquery,
                },
                {
                    label: this.$t("erp.b2c.search_ordertype", {
                        defaultValue: "订单类型",
                    }),
                    key: "orderType",
                    // tag:"vInput",
                    required: false,
                    query: showquery,
                    valueText: {
                        normally: this.$t("erp.b2c.ordertype_normally", {
                            defaultValue: "正常销售",
                        }),
                        celebrity: this.$t("erp.b2c.ordertype_celebrity", {
                            defaultValue: "展示订单",
                        }),
                        distribution: this.$t(
                            "erp.b2c.ordertype_distribution",
                            { defaultValue: "分销订单" }
                        ),
                        brush: this.$t("erp.b2c.ordertype_brush", {
                            defaultValue: "刷评订单",
                        }),
                    }[orderType],
                },
                {
                    label: this.$t("erp.b2c.channel_account", {
                        defaultValue: "渠道账号",
                    }),
                    key: "sourceChannel",
                    tag: "vSelect",
                    query: showquery,
                },
                {
                    label: this.$t("erp.b2c.recipients", {
                        defaultValue: "收件人",
                    }),
                    key: "name",
                    tag: "vInput",
                    query: showquery,
                },
                {
                    label: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: "orderCteateAt",
                    tag: "vInput",
                    query: showquery,
                },
                {
                    label: this.$t("erp.b2border.shipping_address", {
                        defaultValue: "收货地址",
                    }),
                    key: "address",
                    tag: "vInput",
                    query: showquery,
                },
                {
                    label: this.$t("erp.b2c.sales_amount", {
                        defaultValue: "销售金额",
                    }),
                    // key: "saleAmount",
                    // tag:"div",
                    valueText: this.formData.saleAmount
                        ? this.formData.saleAmount +
                          " " +
                          this.formData.currency
                        : "",
                    query: showquery,
                },
                {
                    label:
                        this.$t("erp.b2c.city", { defaultValue: "城市" }) +
                        " | " +
                        this.$t("erp.b2c.state_province", {
                            defaultValue: "州/省份",
                        }) +
                        " | " +
                        this.$tc("global.common.country", 1, {
                            defaultValue: "国家",
                        }),
                    query: showquery,
                    valueText:
                        this.formData.country == undefined
                            ? ""
                            : this.formData.city +
                              " | " +
                              this.formData.state +
                              " | " +
                              this.formData.country,
                },
                {
                    label: this.$t("erp.b2c.delivery_type", {
                        defaultValue: "发货类型",
                    }),
                    key: "fulfillmentChannel",
                    query: showquery,
                },
                {
                    label: this.$t("erp.b2c.zip_code", {
                        defaultValue: "邮编",
                    }),
                    key: "postal",
                    tag: "vInput",
                    query: showquery,
                },
                {
                    label: this.$t("erp.b2c.search_orderstatus", {
                        defaultValue: "订单状态",
                    }),
                    key: "orderState",
                    tag: "vInput",
                    query: showquery,
                    valueText: {
                        pending: this.$t("erp.b2c.orderstatus_pending", {
                            defaultValue: "未支付",
                        }),
                        unshipped: this.$t("erp.b2c.orderstatus_unshipped", {
                            defaultValue: "未发货",
                        }),
                        picking: this.$t("erp.b2c.orderstatus_picking", {
                            defaultValue: "配货中",
                        }),
                        picked: this.$t("erp.b2c.orderstatus_picked", {
                            defaultValue: "已配货",
                        }),
                        shipped: this.$t("erp.b2c.orderstatus_shipped", {
                            defaultValue: "已发货",
                        }),
                        completed: this.$t("global.common.finished", {
                            defaultValue: "已完成",
                        }),
                        canceled: this.$t("erp.b2c.orderstatus_canceled", {
                            defaultValue: "已取消",
                        }),
                        refunded: this.$t("erp.b2c.orderstatus_refunded", {
                            defaultValue: "已退款",
                        }),
                    }[orderState],
                },
                {
                    label: this.$t("erp.b2c.phone", { defaultValue: "电话" }),
                    key: "phone",
                    tag: "vInput",
                    query: showquery,
                },
            ];
        },
        logcolumns() {
            return [
                {
                    title: this.$t("global.log.date", {
                        defaultValue: "操作时间",
                    }),
                    render: (h, { row }) => {
                        return <div>{row.opAt}</div>;
                    },
                },
                {
                    title: this.$t("global.log.operalog", {
                        defaultValue: "操作日志",
                    }),
                    render: (h, { row }) => {
                        return <div>{row.opRemark}</div>;
                    },
                },
                {
                    title: this.$t("global.log.operator", {
                        defaultValue: "操作人",
                    }),
                    render: (h, { row }) => {
                        return <div>{row.opUserName}</div>;
                    },
                },
            ];
        },
        columnsorder() {
            return [
                {
                    title: this.$t("erp.aftersales.contactorder", {
                        defaultValue: "该订单关联的售后单",
                    }),
                    render: (h, { row }) => {
                        return (
                            <a
                                onClick={this.handleOperate.bind(
                                    this,
                                    row.orderId,
                                    "query"
                                )}
                            >
                                {row.orderNo}
                            </a>
                        );
                    },
                },
            ];
        },
        columns() {
            let _this = this;
            return [
                {
                    title: "ERP SKU",
                    key: "erpSku",
                },
                {
                    title: "Seller SKU",
                    key: "sellerSku",
                },
                {
                    // title: "",
                    // key: 'questionNum',
                    renderHeader: (h, params) => {
                        if (_this.type == "query") {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.question_num", {
                                        defaultValue: "问题数量",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                    style: "margin-right:5px",
                                }),
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.question_num", {
                                        defaultValue: "问题数量",
                                    })
                                ),
                            ]);
                        }
                    },
                    render(h, { row, index }) {
                        if (_this.type == "query") {
                            return <div>{row.questionNum}</div>;
                        } else {
                            return h("vInput", {
                                props: {
                                    size: "small",
                                    value: row.questionNum,
                                },
                                on: {
                                    input: (event) => {
                                        row.questionNum = event;
                                        _this.datalist[index] = row;
                                    },
                                },
                            });
                        }
                    },
                },
                {
                    title: this.$t("erp.aftersales.buy_shipnum", {
                        defaultValue: "购买/已发数量",
                    }),
                    render(h, { row }) {
                        if (!row.buyNum) {
                            row.buyNum = row.quantity;
                            row.shippingNum = row.quantity;
                        }
                        return (
                            <div>
                                {row.buyNum}/{row.shippingNum}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("erp.aftersales.after_remark", {
                        defaultValue: "售后原因",
                    }),
                    width: global.SYSID == "1000147" ? 0 : 120,
                    render(h, { row, index }) {
                        if (_this.type == "add" || _this.type == "edit") {
                            if (row.reasonId == 0 || row.reasonId == null) {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "error",
                                                size: "small",
                                            },
                                            on: {
                                                click: () => {
                                                    _this.addAfReason(
                                                        row.erpSku,
                                                        row.sellerSku,
                                                        row.reasonId,
                                                        row.asin,
                                                        index
                                                    );
                                                },
                                            },
                                        },
                                        this.$t("global.common.add", {
                                            defaultValue: "添加",
                                        })
                                    ),
                                ]);
                            } else {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "error",
                                                size: "small",
                                            },
                                            on: {
                                                click: () => {
                                                    _this.addAfReason(
                                                        row.erpSku,
                                                        row.sellerSku,
                                                        row.reasonId,
                                                        row.asin,
                                                        index
                                                    );
                                                },
                                            },
                                        },
                                        this.$t(
                                            "global.common.operation_edit",
                                            { defaultValue: "编辑" }
                                        )
                                    ),
                                ]);
                            }
                        } else if (_this.type == "query") {
                            if (row.reasonId == 0 || row.reasonId == null) {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "error",
                                                size: "small",
                                                disabled: true,
                                            },
                                            on: {
                                                click: () => {},
                                            },
                                        },
                                        this.$t("global.common.operation_see", {
                                            defaultValue: "查看",
                                        })
                                    ),
                                ]);
                            } else {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "error",
                                                size: "small",
                                            },
                                            on: {
                                                click: () => {
                                                    _this.addAfReason(
                                                        row.erpSku,
                                                        row.sellerSku,
                                                        row.reasonId,
                                                        row.asin,
                                                        index
                                                    );
                                                },
                                            },
                                        },
                                        this.$t("global.common.operation_see", {
                                            defaultValue: "查看",
                                        })
                                    ),
                                ]);
                            }
                        }
                    },
                },
            ];
        },
    },
    methods: {
        changeOrderSpource(val) {
            // console.log(val,'3434');
            if (val === 1) {
                this.showSource = false;
                this.checkoutList = ["goods"];
                this.oldcheckoutList = ["refund", "goods", "replace"];
            } else {
                this.showSource = true;
                this.checkoutList = ["refund", "goods", "replace"];
                this.oldcheckoutList = [];
            }
        },
        // 请求详情
        getDetail() {
            let str = window.location.search.split("&")[1] || "";
            let str1 = str.split("=");
            this.loading = true;
            if (this.$route.query.id) {
                this.id = this.id;
                this.type = this.type;
            } else {
                this.id = this.activeids;
                this.type = this.querytype;
            }
            HttpGetOneafSalesByManagement({
                id: this.id,
            })
                .then(
                    (res) => {
                        let array = this.checkoutList.concat();
                        let dataindex1, dataindex2, dataindex3;
                        if (res.data.orderServiceRefund == null) {
                            dataindex1 = array.indexOf("refund");
                        }

                        if (dataindex1 > -1) {
                            array.splice(dataindex1, 1);
                        }

                        if (res.data.orderServiceReturn == null) {
                            dataindex2 = array.indexOf("goods");
                        }
                        if (dataindex2 > -1) {
                            array.splice(dataindex2, 1);
                        }

                        if (res.data.orderServiceReplacement == null) {
                            dataindex3 = array.indexOf("replace");
                        }
                        if (dataindex3 > -1) {
                            array.splice(dataindex3, 1);
                        }
                        this.checkoutList = array;
                        this.oldcheckoutList = this.checkoutList.concat();
                        this.formData = res.data.orderServiceBaseInfo;
                        this.datalist = res.data.orderServiceItemList
                            ? res.data.orderServiceItemList
                            : [];
                        (this.orderServiceBaseInfo =
                            res.data.orderServiceBaseInfo),
                            (this.orderServiceRefund = res.data
                                .orderServiceRefund
                                ? res.data.orderServiceRefund
                                : []);
                        this.orderServiceReturn = res.data.orderServiceReturn
                            ? {
                                  ...res.data.orderServiceBaseInfo,
                                  ...res.data.orderServiceReturn,
                              }
                            : res.data.orderServiceBaseInfo;
                        this.orderServiceReplacement = res.data
                            .orderServiceReplacement
                            ? res.data.orderServiceReplacement
                            : res.data.orderServiceBaseInfo;
                        this.stockOpLogList = res.data.stockOpLogList;

                        // 三个详情页的列表
                        if (res.data.orderServiceRefund != null) {
                            this.refundtable =
                                res.data.orderServiceRefund.orderServiceItemList;
                        } else {
                            this.refundtable = res.data.orderServiceItemList;
                        }
                        if (res.data.orderServiceReturn != null) {
                            this.returntable =
                                res.data.orderServiceReturn.orderServiceItemList;
                        } else {
                            this.returntable = res.data.orderServiceItemList;
                        }
                        if (res.data.orderServiceReplacement != null) {
                            this.placementtable =
                                res.data.orderServiceReplacement.orderServiceItemList;
                        } else {
                            this.placementtable = res.data.orderServiceItemList;
                        }

                        if (this.formData.noOrderSource === 1) {
                            this.showSource = false;
                            this.checkoutList = ["goods"];
                            this.oldcheckoutList = [
                                "refund",
                                "goods",
                                "replace",
                            ];
                        }

                        // this.getOrderNoList()
                    },
                    (err) => {
                        this.errorMessage(err.message);
                    }
                )
                .finally((res) => [(this.loading = false)]);
        },
        addAfReason(erp, seller, reasonId, asin, index) {
            let data = {
                erpSku: erp,
                sellerSku: seller,
                lineId: this.formData.lineId,
                sourceChannel: this.formData.sourceChannel,
                orderNo: this.formData.orderNo,
                orderEmail: this.formData.email,
                asin: asin,
                sourcePhone: this.formData.phone,
                issueStatus: "INPROCESS",
                dataindex: index,
            };
            sessionStorage.set("salesdata", JSON.stringify(data));
            this.btnindexid = index;
            if (this.type == "add" || this.type == "edit") {
                sessionStorage.set("comcustype", "comcustype");
                if (reasonId == 0 || reasonId == null) {
                    this.handle = {
                        title:
                            this.$t("global.common.add", {
                                defaultValue: "添加",
                            }) + "Customer Service Summary",
                        show: true,
                        width: 1100,
                        component: "comCusUpdate",
                        reasonid: reasonId,
                        comorderno: reasonId + 1,
                        comerpsku: erp,
                        comtype: "add",
                    };
                } else {
                    this.handle = {
                        title:
                            this.$t("global.common.operation_edit", {
                                defaultValue: "编辑",
                            }) + "Customer Service Summary",
                        show: true,
                        width: 1100,
                        component: "comCusUpdate",
                        reasonid: reasonId,
                        comorderno: reasonId + 1,
                        comtype: "edit",
                    };
                }
            } else {
                this.handle = {
                    title:
                        this.$t("global.common.operation_see", {
                            defaultValue: "查看",
                        }) + "Customer Service Summary",
                    show: true,
                    width: 1100,
                    component: "comCusUpdate",
                    reasonid: reasonId,
                    comorderno: reasonId,
                    comtype: "query",
                    querytype: "query",
                };
            }

            // console.log(this.type)
        },
        getBtnId(btnid) {
            // console.log(33333333)
            let ary = sessionStorage.get("custupdate");
            let custerDetail = JSON.parse(ary);
            // console.log(this.btnindexid)
            this.datalist[this.btnindexid].serviceSummaryRequest = {
                serviceSummaryBaseInfo: custerDetail.serviceSummaryBaseInfo,
                issueId: custerDetail.issueId,
                serviceSummaryItemList: custerDetail.serviceSummaryItemList,
                serviceSummaryAnnexList: custerDetail.serviceSummaryAnnexList,
            };
            this.closeCusfun();
        },
        closeCusfun() {
            this.handle.show = false;
        },
        handleOrderList() {
            // console.log(123123123)

            this.$VModal.info({
                title: this.$t("erp.channelbase.order", {
                    defaultValue: "订单",
                }),
                width: 1000,
                showFooter: false,
                render: (h, props) => {
                    return this.$createElement("orderTablelist", {
                        props: {
                            products: this.getNewProductList,
                        },
                        on: {
                            rows: (rows) => {
                                this.loading = true;
                                sessionStorage.set("custupdate", null);
                                // 请求单条 的接口
                                this.formData.orderServiceNo =
                                    rows.orderServiceNo;
                                this.datalist = [];
                                this.formData = {
                                    orderServiceNo: "",
                                };
                                this.orderServiceRefund = {};
                                this.orderServiceReturn = {};
                                this.orderServiceReplacement = {};

                                this.$set(
                                    this.$data,
                                    "inputOrderNo",
                                    rows.orderNo
                                );
                                // 头部点击切换订单
                                this.getOrderNoList(
                                    rows.orderNo,
                                    rows.channelFlag
                                );
                                this.$VModal.destroy();
                            },
                            cancel: () => {
                                this.$VModal.destroy();
                            },
                        },
                    });
                },
            });
        },
        getOrderNoList(orderNo, channelFlag) {
            HttpGetOrderNo({
                orderNo: orderNo,
                sourceChannel: channelFlag,
            }).then(
                (res) => {
                    // console.log(res)
                    this.dataorders = res.data.orderServiceNos;
                    this.formData =
                        res.data.orderServiceInfo.orderServiceBaseInfo;
                    this.datalist =
                        res.data.orderServiceInfo.orderServiceItemList;
                    this.orderServiceBaseInfo =
                        res.data.orderServiceInfo.orderServiceBaseInfo;
                    this.orderServiceRefund = res.data.orderServiceRefund || {};
                    this.orderServiceReturn =
                        res.data.orderServiceReturn ||
                        res.data.orderServiceReplacement;
                    this.orderServiceReplacement =
                        res.data.orderServiceReplacement || {};

                    this.refundtable =
                        res.data.orderServiceInfo.orderServiceItemList;
                    this.returntable =
                        res.data.orderServiceInfo.orderServiceItemList;
                    this.placementtable =
                        res.data.orderServiceInfo.orderServiceItemList;
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                }
            );
        },
        async submit() {
            if (this.checkoutList.length < 1) {
                this.$Message.error(
                    this.$t("erp.aftersales.chosetypes", {
                        defaultValue: "请选择售后单类型",
                    })
                );
                return;
            }
            let refRefund = this.$refs.refRefund;
            let refGoods = this.$refs.refGoods;
            let refReplace = this.$refs.refReplace;

            if (!this.hasTip) {
                // 退货单作废时必须先作废补发单
                // if ((refGoods && refGoods.formData.returnStatus === 'NULLIFY') || (refReplace && refReplace.formData.replacementStatus === 'NULLIFY')) {
                if (
                    refReplace &&
                    refReplace.formData.replacementStatus === "NULLIFY"
                ) {
                    return this.$VModal.error({
                        title: this.$t("erp.aftersales.attention", {
                            defaultValue: "提示",
                        }),
                        width: 480,
                        showFooter: false,
                        render: (h, props) => {
                            return this.$createElement("tipText", {
                                props: {
                                    descText: this.$t(
                                        "erp.aftersales.tipText",
                                        {
                                            defaultValue:
                                                "注意：作废售后单不会同步取消自动生成的补发单，请取消补发单（B2C订单页面）后再作废售后单！",
                                        }
                                    ),
                                    descClass: "color-error",
                                },
                                on: {
                                    ok: () => {
                                        this.hasTip = true;
                                        this.$VModal.destroy();
                                        this.submit();
                                    },
                                    cancel: () => {
                                        this.$VModal.destroy();
                                    },
                                },
                            });
                        },
                    });
                }
            }

            let dataflag;
            if (this.datalist.length > 0) {
                this.datalist.map((item) => {
                    if (!item.questionNum) {
                        dataflag = true;
                    }
                });
            }
            if (dataflag) {
                this.$VMessage.error(
                    this.$t("erp.aftersales.check_num", {
                        defaultValue: "请检查问题数量",
                    })
                );
                return;
            }

            if (this.checkoutList.indexOf("refund") > -1) {
                let bool1 = await this.$refs.refRefund.validate();
                if (!bool1) return;
            }

            if (this.checkoutList.indexOf("goods") > -1) {
                let data, trackinig, returnMode;
                if (refGoods.datalist.length > 0) {
                    refGoods.datalist.find((item) => {
                        if (!item.returnNum || item.returnNum == "0") {
                            data = true;
                        }
                        if (
                            !item.trackingNo &&
                            refGoods.formData.returnStatus == "RETURNED"
                        ) {
                            trackinig = true;
                        }
                        if (item.returnMode == null || item.returnMode == "") {
                            returnMode = true;
                        }
                    });
                }
                if (data) {
                    this.$VMessage.error(
                        this.$t("erp.aftersales.goodsnummax", {
                            defaultValue: "退货数量必须大于0",
                        })
                    );
                    return;
                }
                if (trackinig) {
                    this.$VMessage.error(
                        this.$t("erp.aftersales.writetrack", {
                            defaultValue: "请填写Tracking",
                        })
                    );
                    return;
                }
                if (returnMode) {
                    this.$VMessage.error(
                        this.$t("erp.aftersales.chosegoddsway", {
                            defaultValue: "请选择退货方式",
                        })
                    );
                    return;
                }
                let bool2 = await this.$refs.refGoods.validate();
                if (!bool2) return;
            }

            if (this.checkoutList.indexOf("replace") > -1) {
                let data;
                if (refReplace.datalist.length > 0) {
                    refReplace.datalist.find((item) => {
                        if (
                            item.replacementNum == null ||
                            item.replacementNum == "0"
                        ) {
                            data = true;
                        }
                    });
                }
                if (data) {
                    this.$VMessage.error(
                        this.$t("erp.aftersales.replace ", {
                            defaultValue: "补发",
                        }) +
                            this.$t("erp.channel.number_gt", {
                                defaultValue: "数量大于",
                            }) +
                            "0"
                    );
                    return;
                }

                if (
                    !this.$refs.refReplace.formData.orgWarehouseCode ||
                    !this.$refs.refReplace.formData.shippingMode ||
                    this.$refs.refReplace.formData.country == undefined ||
                    this.$refs.refReplace.formData.country == "" ||
                    this.$refs.refReplace.formData.state == "" ||
                    this.$refs.refReplace.formData.state == undefined
                ) {
                    this.$VMessage.error(
                        this.$t("global.form.require", {
                            defaultValue: "请填写必填项",
                        })
                    );
                    return;
                }
                let bool3 = await this.$refs.refReplace.validate();
                if (!bool3) return;
            }

            let orderServiceRefund, orderServiceReturn, orderServiceReplacement;
            if (this.checkoutList.indexOf("refund") > -1) {
                orderServiceRefund = {
                    ...refRefund.formData,
                    orderServiceItemList: refRefund.datalist,
                };
            } else {
                orderServiceRefund = null;
            }

            if (this.checkoutList.indexOf("goods") > -1) {
                let origcode;
                this.warehouseList.map((item) => {
                    if (refGoods.formData.orgWarehouseId == item.id) {
                        origcode = item.code;
                    }
                });
                orderServiceReturn = {
                    ...refGoods.formData,
                    orgWarehouseCode: origcode || "",
                    orderServiceItemList: refGoods.datalist,
                };
            } else {
                orderServiceReturn = null;
            }

            if (this.checkoutList.indexOf("replace") > -1) {
                let origid;
                if (refReplace.formData.orgWarehouseCode == "AUTO") {
                    origid = 0;
                } else {
                    this.warehouseList.map((item) => {
                        if (refReplace.formData.orgWarehouseCode == item.code) {
                            origid = item.id;
                        }
                    });
                }
                orderServiceReplacement = {
                    ...refReplace.formData,
                    orgWarehouseId: origid,
                    orderServiceItemList: refReplace.datalist,
                };
            } else {
                orderServiceReplacement = null;
            }

            sessionStorage.set("comcustype", "0");

            this.loading = true;

            // console.log(this.datalist)
            // 点击无订单的状况
            if (this.noOrderSource === 1) {
                this.formData.noOrderSource = 1;
            }

            HttpsaveOneafSales({
                orderServiceBaseInfo: this.formData,
                orderServiceItemList: this.datalist || null,
                orderServiceRefund: orderServiceRefund || null,
                orderServiceReturn: orderServiceReturn,
                orderServiceReplacement: orderServiceReplacement || null,
            })
                .then(
                    (res) => {
                        this.$Message.success(res.message);
                        this.$router.push({
                            name: "afterSaleordersAdmin",
                        });
                    },
                    (err) => {
                        this.errorMessage(err.message);
                    }
                )
                .finally((res) => {
                    this.hasTip = false;
                    this.loading = false;
                    sessionStorage.set("custupdate", "");
                });
        },
        cancel() {
            // 跳转到列表页
            this.$router.push({
                name: "afterSaleordersAdmin",
            });
        },
        // 点击售后关联订单，跳转详情
        handleOperate(params = "", type) {
            switch (type) {
                case "query":
                    this.handle = {
                        title:
                            this.$t("global.common.operation_see", {
                                defaultValue: "查看",
                            }) +
                            this.$t("erp.aftersales.orderServiceNo", {
                                defaultValue: "售后单",
                            }),
                        show: true,
                        width: 1100,
                        component: "comUpdate",
                        indexid: params,
                        showindex: "queryindex",
                        comtype: "query",
                    };
                    break;
            }
        },
        filterStatus(val) {
            switch (val) {
                case "ESTABLISH":
                    return this.$t("fbb.costmanage.created", {
                        defaultValue: "已创建",
                    });
                    break;
                case "INPROCESS":
                    return this.$t("bi.work.task_status_processing", {
                        defaultValue: "处理中",
                    });
                    break;
                case "FINISHED":
                    return this.$t("global.upload.complete", {
                        defaultValue: "已完成",
                    });
                    break;
                case "ARRANGED":
                    return this.$t("global.upload.before_archive", {
                        defaultValue: "已归档",
                    });
                    break;
                case "NULLIFY":
                    return this.$t("erp.aftersales.nullify", {
                        defaultValue: "已作废",
                    });
                    break;
            }
        },
    },
};
</script>
